export default "__VITE_ASSET__1cf87e33__"